























































































import {
	getConfig,
	updateConfig,
	LABELED_ADDITION_TYPES,
	LABELED_ADDITION_TYPES_DEMO,
	ADDITION_DIGITS,
	getAdditionalDigits,
	ADDITION_PRO_DIGITS,
	getAdditionalProDigits,
	ADDITION_TYPES,
	getAbacusVariants,
	PLACES,
	ADDITION_DIGITS_DEMO,
	DEFAULT_ANZAN_TYPE,
} from '../gameConfig'
import { Vue, Component, Watch } from 'vue-property-decorator'
import Checkbox from './Checkbox.vue'
import LanguageSelect from '@/components/LanguageSelect.vue'
import Select from '@/components/UI/Select.vue'

@Component({
	components: {
		Checkbox,
		LanguageSelect,
		Select
	},
	computed: {
		anzanType() {
			return [
				{ value: 'anzan_random', label: 'Random numbers' },
				{ value: 'anzan_minus', label: 'Only subtraction' },
				{ value: 'anzan_plus', label: 'Only add' },
			]
		},
	},
})
export default class Addition extends Vue {
	config = {
		speed: '',
		length: 3,
		places: '',
		type: 'abacus_random_2',
		digit: [],
		withSound: false,
		digit_type: DEFAULT_ANZAN_TYPE,
		pro: false,
	}
	language = ''

	changeSpeed(val: 0.1 | -0.1) {
		if (+this.config.speed === 0.1 && val === -0.1) return false
		let newVal = +this.config.speed + val
		this.config.speed = newVal.toFixed(1)
	}

	onBlurLength() {
		if (this.config.length < 1) {
			this.config.length = 1
		}
	}

	changeLength(val: 1 | -1) {
		if (+this.config.length === 1 && val === -1) return false
		this.config.length += val
	}

	startGame() {
		this.$store.commit('changeGameConfig', this.config)
		this.$router.push({ path: this.isDemo ? '/demo/game' : '/games/game' })
	}

	// Reset digit to default for new type
	// onChangeType() {
	// 	this.config.digit = [1, 10] //this.digits[0].toString()
	// }

	// get digitMode() {
	// 	return `${this.config.digit}${this.config.pro ? 'pro' : ''}`
	// }

	// set digitMode(newValue) {
	// 	const currentMode = String(newValue)

	// 	console.log(currentMode)
	// 	console.log(parseInt(currentMode), currentMode.includes('pro'))

	// 	this.config.digit = [1, 10] //String(parseInt(currentMode))
	// 	this.config.pro = currentMode.includes('pro')
	// }

	get additionalType() {
		return this.isDemo ? LABELED_ADDITION_TYPES_DEMO : LABELED_ADDITION_TYPES
	}

	get isCustomBgEnabled() {
		return !!this.$store.getters.primaryBackground
	}

	get digits() {
		const type = 'big_friends' as keyof typeof ADDITION_DIGITS //this.config.type
		return this.isDemo
			? ADDITION_DIGITS_DEMO
			: getAdditionalDigits(type, +this.config.places)
	}

	// get digits() {
	// 	const type = this.config.type
	// 	return this.isDemo
	// 		? ADDITION_DIGITS_DEMO
	// 		: getAdditionalDigits(type, +this.config.places)
	// }

	get digitsPro() {
		const type = 'big_friends' as keyof typeof ADDITION_DIGITS
		return this.isDemo
			? ADDITION_DIGITS_DEMO
			: getAdditionalProDigits(type, +this.config.places)
	}

	get disabledWithSound() {
		const { places, speed } = this.config
		return (+speed < 1 && +places <= 10) || (+places >= 100 && +speed < 2.5)
	}

	get complexityList() {
		return this.isDemo ? [1] : PLACES
	}

	get isDemo() {
		return !!this.$route.path.startsWith('/demo')
	}

	get digitOptions() {
		return getAbacusVariants(Number(this.config.places))
	}

	@Watch('config', { deep: true })
	onConfigChanged(val: any) {
		updateConfig({ abacusRandom: () => val }, !this.isDemo)
	}

	@Watch('config.places')
	validateDigit(val: any, oldVal: any) {
		if (oldVal !== '') {
			this.config.digit = this.digitOptions[0][0]
		}
	}

	@Watch('config.type')
	validateType() {
		if (this.config.type != 'abacus_random_2') {
			this.config.type = 'abacus_random_2'
		}
	}

	// @Watch('config.digit')
	// validateDigit2() {

	// 	this.config.digit = [1, 10]

	// }

	@Watch('config.length')
	validateLength() {
		if (this.config.length > 25) {
			this.config.length = 25
		}
	}
	created() {
		// Setup default values
		const config = getConfig(undefined)
		this.config = config.abacusRandom as any
	}
}
